import axios from 'axios';
import { config } from 'config';
import axiosRetry from 'axios-retry';
import { Tokens } from 'types';
import { catchHandler, setTokens } from './PromiseHandlers';
import { getCookie } from 'utils';
import { AxiosUtils } from '../AxiosClient/AxiosClient';

class Authentication {
  private readonly client;

  public constructor() {
    this.client = axios.create({
      baseURL: config.URL_USER_MANAGEMENT,
      headers: {
        'x-client-source': config.X_CLIENT_SOURCE,
        'Content-Type': 'application/json',
      },
    });
    AxiosUtils.addDefaultInterceptor(this.client);
    axiosRetry(this.client, {
      retries: 3,
      retryDelay: retryCount => retryCount * 500,
      shouldResetTimeout: true,
      retryCondition: error => {
        return axiosRetry.isNetworkOrIdempotentRequestError(error) || error.code === 'ECONNABORTED';
      },
    });
  }

  async authenticate(email: string, password: string): Promise<Tokens> {
    return this.client
      .post<Tokens>('v1/authenticate/user', {
        username: email,
        password,
        site: config.USER_MANAGEMENT_SITE,
      })
      .then(setTokens)
      .catch(r => catchHandler(r, 'authenticate/user'));
  }

  async authenticateWithRefreshToken(refreshToken: string): Promise<Tokens> {
    return this.client
      .post<Tokens>('v1/authenticate/user', {
        refreshToken,
      })
      .then(setTokens);
  }

  async refresh(): Promise<Tokens> {
    const refreshToken = getCookie('refresh-token');
    if (!refreshToken) {
      return Promise.reject('Error, no refresh token');
    }
    return this.authenticateWithRefreshToken(refreshToken);
  }
}

export const AuthenticationService = new Authentication();
